import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type LocationModel from 'bcl/models/location';
import Wide from 'bcl/components/input/wide';
import Checkbox from 'bcl/components/input/checkbox';
import { on } from '@ember/modifier';

interface LocationEditSignature {
  // The arguments accepted by the component
  Args: {
    model: LocationModel;
    closeModal: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class LocationEditComponent extends Component<LocationEditSignature> {
  <template>
    <form class="mx-4 sm:mx-0">
      <div class="space-y-12">
        <div class="border-b border-gray-900/10 pb-4">
          <h2 class="text-base font-semibold leading-7 text-gray-900">Lager
            Stammdaten</h2>

          <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">

            <Wide
              @label="Name"
              @name="name"
              @type="text"
              @value={{@model.name}}
            />
            <Checkbox @label="Active" @name="active" @value={{@model.active}} />

          </div>
        </div>
      </div>

      <div class="mt-6 flex items-center justify-end gap-x-6">
        <button
          {{on "click" this.cancel}}
          type="button"
          class="text-sm font-semibold leading-6 text-gray-900"
        >abbrechen</button>
        <button
          {{on "click" this.save}}
          type="button"
          class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >Speichern</button>
      </div>
    </form>
  </template>
  @service store;

  @action
  async cancel() {
    this.args.model.rollbackAttributes();
    this.args.closeModal();
  }
  @action
  async save() {
    const item = this.args.model;
    if (item.hasDirtyAttributes) {
      await item.save();
    }
    this.args.closeModal();
  }
}
